(() => {
  if (window.bothCardTransformLoopLoaded) return;
  window.bothCardTransformLoopLoaded = true;

  const mobile = window.matchMedia('(max-width: 767px)');
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const states = new WeakMap();

  function setup(track) {
    if (states.has(track)) return;

    const slides = Array.from(track.children).filter((element) =>
      element.matches('.both-card-swipe__slide')
    );

    if (slides.length < 2) return;

    const count = slides.length;
    const dotsWrapper = track.nextElementSibling;
    const dots = dotsWrapper?.matches('.both-card-swipe-dots')
      ? Array.from(dotsWrapper.children)
      : [];

    const strip = document.createElement('div');
    strip.className = 'both-card-swipe__strip';

    function copySlide(slide) {
      const copy = slide.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');

      copy.querySelectorAll('[id]').forEach((element) => {
        element.removeAttribute('id');
      });

      return copy;
    }

    strip.append(copySlide(slides[count - 1]));
    slides.forEach((slide) => strip.append(slide));
    strip.append(copySlide(slides[0]));

    track.append(strip);
    track.classList.add('both-card-swipe--loop');

    const state = {
      position: 1,
      busy: false,
      timer: null,
      x: 0,
      y: 0,
      tracking: false,
      moved: false,
      blockUntil: 0
    };

    states.set(track, state);

    function updateDots() {
      const index = (state.position - 1 + count) % count;

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function paint(animate) {
      strip.style.transition = animate
        ? 'transform 240ms ease'
        : 'none';

      strip.style.transform =
        `translate3d(${-state.position * 100}%, 0, 0)`;

      updateDots();
    }

    function finish() {
      if (!state.busy) return;

      clearTimeout(state.timer);

      if (state.position === 0) {
        state.position = count;
      } else if (state.position === count + 1) {
        state.position = 1;
      }

      paint(false);
      state.busy = false;
    }

    function move(direction) {
      if (!mobile.matches || state.busy) return;

      state.busy = true;
      state.position += direction;

      // Commit the reset before starting another transition.
      void strip.offsetWidth;

      const animate = !reducedMotion.matches;
      paint(animate);

      if (animate) {
        state.timer = setTimeout(finish, 320);
      } else {
        finish();
      }
    }

    strip.addEventListener('transitionend', (event) => {
      if (
        event.target === strip &&
        event.propertyName === 'transform'
      ) {
        finish();
      }
    });

    track.addEventListener('touchstart', (event) => {
      if (!mobile.matches || event.touches.length !== 1) {
        state.tracking = false;
        return;
      }

      finish();

      state.x = event.touches[0].clientX;
      state.y = event.touches[0].clientY;
      state.moved = false;
      state.tracking = true;
      state.blockUntil = 0;
    }, { passive: true });

    track.addEventListener('touchmove', (event) => {
      if (!state.tracking || event.touches.length !== 1) return;

      const dx = event.touches[0].clientX - state.x;
      const dy = event.touches[0].clientY - state.y;

      if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
        state.moved = true;
        state.blockUntil = Date.now() + 700;
      }

      // Keep vertical page scrolling available.
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        if (event.cancelable) event.preventDefault();
      }
    }, { passive: false });

    track.addEventListener('touchend', (event) => {
      if (!state.tracking) return;
      state.tracking = false;

      if (state.moved) {
        state.blockUntil = Date.now() + 700;
      }

      const touch = event.changedTouches[0];
      if (!touch) return;

      const dx = touch.clientX - state.x;
      const dy = touch.clientY - state.y;

      if (Math.abs(dx) >= 30 && Math.abs(dx) > Math.abs(dy)) {
        state.blockUntil = Date.now() + 700;
        move(dx < 0 ? 1 : -1);
      }
    }, { passive: true });

    track.addEventListener('touchcancel', () => {
      state.tracking = false;

      if (state.moved) {
        state.blockUntil = Date.now() + 700;
      }
    }, { passive: true });

    track.addEventListener('keydown', (event) => {
      if (!mobile.matches) return;

      if (['ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });

    paint(false);
  }

  function scan(root) {
    if (!(root instanceof Element || root instanceof Document)) {
      return;
    }

    if (
      root instanceof Element &&
      root.matches('[data-both-card-swipe]')
    ) {
      setup(root);
    }

    root.querySelectorAll('[data-both-card-swipe]').forEach(setup);
  }

  // Prevent an image swipe from also opening its product link.
  document.addEventListener('click', (event) => {
    if (!mobile.matches || !(event.target instanceof Element)) {
      return;
    }

    const track = event.target.closest('[data-both-card-swipe]');
    const state = track && states.get(track);

    if (state && Date.now() < state.blockUntil) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  scan(document);

  // Initialize cards added by filtering or editor updates.
  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach(scan);
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
